"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Sun = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Sun_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5a.5.5 0 0 0-1 0v2.024c0 .268.232.476.5.476s.5-.208.5-.476V.5ZM5.695 3.007c.134.232.036.528-.196.662a.489.489 0 0 1-.67-.162L3.818 1.755a.5.5 0 1 1 .866-.5l1.011 1.752ZM3.67 5.499a.489.489 0 0 0-.163-.67L1.754 3.817a.5.5 0 1 0-.5.866l1.753 1.012c.232.134.528.036.663-.196ZM2.524 7.5c.268 0 .476.232.476.5s-.208.5-.476.5H.5a.5.5 0 0 1 0-1h2.024ZM3.67 10.501c-.135-.232-.43-.33-.663-.196l-1.753 1.012a.5.5 0 1 0 .5.866l1.753-1.012a.489.489 0 0 0 .163-.67ZM4.828 12.492a.489.489 0 0 1 .67-.162c.232.134.33.43.196.663l-1.012 1.752a.5.5 0 0 1-.866-.5l1.012-1.752ZM8 13c-.268 0-.5.208-.5.476V15.5a.5.5 0 0 0 1 0v-2.024c0-.268-.232-.476-.5-.476ZM10.306 12.993c-.134-.232-.036-.529.196-.663a.489.489 0 0 1 .67.163l1.012 1.752a.5.5 0 1 1-.866.5l-1.012-1.752ZM12.33 10.502a.489.489 0 0 0 .163.67l1.752 1.011a.5.5 0 1 0 .5-.866l-1.752-1.011c-.232-.134-.529-.036-.663.196ZM13.476 8.5C13.208 8.5 13 8.268 13 8s.208-.5.476-.5H15.5a.5.5 0 0 1 0 1h-2.024ZM12.33 5.499c.134.231.43.33.663.196l1.752-1.012a.5.5 0 1 0-.5-.866l-1.752 1.012a.489.489 0 0 0-.163.67ZM11.17 3.507a.489.489 0 0 1-.67.162c-.231-.134-.33-.43-.195-.662l1.011-1.752a.5.5 0 1 1 .866.5l-1.011 1.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Sun_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Sun;
exports["default"] = _default;